// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__OcNeV","right":"styles_right__1TsrD"};